<template>
    <b-card :title="`Detalles de la tarea: ${theData.item.name}`">
        <b-tabs>
            <b-tab title="Contenido" active>
                <app-taks-details-content :data="theData" />
            </b-tab>
            <b-tab title="Historial de eventos">
                <app-task-details-log :logs="theData.item.task_log" />
            </b-tab>
            <b-tab title="Observadores">
                <app-task-details-watchers :watchers="theData.item.watchers"
                />
            </b-tab>
            <b-tab title="Etiquetas">
                <app-task-details-tags :tags="theData.item.task_tags"
                />
            </b-tab>
        </b-tabs>
        <template slot="footer">
            <div class="d-flex justify-content-end">
                <b-button variant="danger" @click="theData.toggleDetails">Cerrar detalles</b-button>
            </div>
        </template>
    </b-card>
</template>
<script>
import TaksDetailsContent from './TaksDetailsContent.vue';
import TaskDetailsLog from './TaskDetailsLog.vue';
import TaskDetailsWatchers from './TaskDetailsWatchers.vue';
import TaskDetailsTags from './TaskDetailsTags.vue';
export default {
    components: {
        appTaksDetailsContent: TaksDetailsContent,
        appTaskDetailsLog: TaskDetailsLog,
        appTaskDetailsWatchers: TaskDetailsWatchers,
        appTaskDetailsTags: TaskDetailsTags
    },
    props: {
        theData: {
            type: Object,
            required: true
        }
    }
}
</script>